"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.sub");
require("core-js/modules/web.dom.iterable");
var _vueHtml2pdf = _interopRequireDefault(require("vue-html2pdf"));
var _courseDeclare = require("@/api/courseDeclare/courseDeclare");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      showLayout: false,
      isDown: false,
      showDown: false,
      isDownBtn: 0,
      userInfo: {},
      declareType: '认定',
      declareOption: [{
        name: '认定',
        value: '认定'
      }, {
        name: '建设',
        value: '建设'
      }],
      teacherAll: [],
      addDeclareType: '',
      form: {
        matchId: this.$route.query.id,
        courseLeader: "",
        courseName: ""
      },
      rules: {
        // contactNumber: [
        //   { validator: validatePhoneTwo, trigger: "blur" }
        // ],
      },
      dialog: false,
      dialog2: false,
      dialog3: false,
      secondDetail: {
        courseHourList: [],
        courseTeamList: [],
        courseTeamOtherList: []
      },
      thirdDetail: {
        courseLeaderTeachingList: [],
        courseTeamList: [],
        courseEachLectureList: []
      },
      //附件2 for循环 左侧colspan值

      //附件3 for循环 左侧colspan值
      teachingList: 5,
      teamList: 2,
      lectureList: 2,
      num: 10,
      //
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "项目名称"
      }, {
        label: "推荐状态",
        type: "select",
        model: "tuijian",
        placeholder: "推荐状态",
        options: [{
          name: "待填写",
          value: 0
        }, {
          name: "已保存",
          value: 1
        }, {
          name: "学校审核",
          value: 2
        }, {
          name: "市审核",
          value: 4
        }, {
          name: "省审核",
          value: 6
        }, {
          name: "已完成",
          value: 8
        }]
      }],
      modelData: {
        queryValue: "",
        tuijian: ""
      },
      minWidth: 300,
      page: {
        matchId: this.$route.query.id,
        name: '',
        state: '',
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      searchName: "",
      checkBoxData: []
    };
  },
  methods: {
    downPDF2: function downPDF2() {
      var _this = this;
      this.isDown = true;
      setTimeout(function () {
        _this.exportPdfHandler('dao2', '江苏省职业教育精品在线开放课程验收认定申报书');
        setTimeout(function () {
          _this.isDown = false;
        }, 3000);
      }, 1000);
    },
    downPDF3: function downPDF3() {
      var _this2 = this;
      this.isDown = true;
      setTimeout(function () {
        _this2.exportPdfHandler('dao3', '江苏省职业教育精品在线开放课程立项建设申报书');
        setTimeout(function () {
          _this2.isDown = false;
        }, 3000);
      }, 1000);
    },
    //批量选择时
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;
      this.checkBoxData = [];
      val.forEach(function (item) {
        _this3.checkBoxData.push(item.id);
      });
    },
    //已选择的标签禁用状态tagList  tagGroups   tagsItem
    isdisabled: function isdisabled(row, index) {
      if (this.userInfo.roleType == 5) {
        if (row.state == 1 || row.state == 3) {
          return true;
        }
      }
      if (this.userInfo.roleType == 3) {
        if (row.state == 2 || row.state == 5) {
          return true;
        }
        if (row.schoolType == 2 && row.state == 7) {
          return true;
        }
      }
      if (this.userInfo.roleType == 2 && row.schoolType == 1) {
        if (row.state == 4 || row.state == 7) {
          return true;
        }
      }
      if (this.userInfo.roleType == 1 && row.state == 6) {
        return true;
      }
    },
    subReviewOnly: function subReviewOnly(id, result) {
      this.checkBoxData = [];
      var ids = [];
      ids.push(id);
      var re = result;
      this.subReview(ids, re);
    },
    subReviewBatch: function subReviewBatch(arr, result) {
      if (arr.length > 0) {
        var ids = arr;
        var re = result;
        this.subReview(ids, re);
      } else {
        this.$message.error('请先选择需要批量操作的内容');
      }
    },
    //学校 市 省 1推荐 / 0退回 申报书
    subReview: function subReview(ids, result) {
      var _this4 = this;
      if (this.declareType === '认定') {
        (0, _courseDeclare.schoolReviewSecond)({
          ids: ids,
          result: result
        }).then(function (res) {
          if (res.code === 2000) {
            _this4.$message.success(res.msg);
            _this4.declareType = '认定';
            _this4.getList();
          }
        });
      } else if (this.declareType === '建设') {
        (0, _courseDeclare.schoolReviewThird)({
          ids: ids,
          result: result
        }).then(function (res) {
          if (res.code === 2000) {
            _this4.$message.success(res.msg);
            _this4.declareType = '建设';
            _this4.getList();
          }
        });
      }
    },
    //老师 向学校提交申报书
    subOnly: function subOnly(id) {
      this.checkBoxData = [];
      var ids = [];
      ids.push(id);
      this.sub(ids);
    },
    subBatch: function subBatch(arr) {
      if (arr.length > 0) {
        var ids = arr;
        this.sub(ids);
      } else {
        this.$message.error('请先选择需要批量操作的内容');
      }
    },
    sub: function sub(ids) {
      var _this5 = this;
      if (this.declareType === '认定') {
        (0, _courseDeclare.teacherSubmitSecond)({
          idList: ids
        }).then(function (res) {
          if (res.code === 2000) {
            _this5.$message.success(res.msg);
            _this5.declareType = '认定';
            _this5.getList();
          }
        });
      } else if (this.declareType === '建设') {
        (0, _courseDeclare.teacherSubmitThird)({
          idList: ids
        }).then(function (res) {
          if (res.code === 2000) {
            _this5.$message.success(res.msg);
            _this5.declareType = '建设';
            _this5.getList();
          }
        });
      }
    },
    // 老师 填写申报书
    fillIn: function fillIn(id) {
      console.log('点了吗');
      console.log('this.declareType', this.declareType);
      if (this.declareType === '认定') {
        this.$router.push({
          path: "/courseDeclare/acceptance",
          query: {
            id: id
          }
        });
      } else if (this.declareType === '建设') {
        this.$router.push({
          path: "/courseDeclare/courseProEs",
          query: {
            id: id
          }
        });
      }
    },
    // 模糊搜索
    search: function search(v) {
      // console.log('ppp',v)
      this.page.name = v.queryValue;
      this.page.state = v.tuijian;
      this.getList();
    },
    changeType: function changeType(val) {
      this.page.pageNumber = 1;
      this.declareType = val;
      this.getList();
    },
    addCourse: function addCourse() {
      this.dialog = true;
    },
    closePDF: function closePDF() {
      this.isDown = false;
      this.showDown = false;
    },
    close: function close() {
      this.dialog = false;
      this.form = {
        matchId: this.$route.query.id,
        courseLeader: "",
        courseName: ""
      };
    },
    // 学校 添加申报课程 提交
    submit: function submit(v) {
      var _this6 = this;
      if (this.addDeclareType == '') {
        this.$message.error('请先选择课程类别');
      } else if (this.form.courseName == '') {
        this.$message.error('请先填写课程名称');
      } else if (this.form.courseLeader == '') {
        this.$message.error('课程负责人不能为空');
      } else {
        this.$refs[v].validate(function (valid) {
          if (valid) {
            if (_this6.addDeclareType === '认定') {
              (0, _courseDeclare.insertFirstCourseSecond)(_this6.form).then(function (res) {
                if (res.code === 2000) {
                  _this6.$message.success(res.msg);
                  _this6.dialog = false;
                  _this6.form = {
                    matchId: _this6.$route.query.id,
                    courseLeader: "",
                    courseName: ""
                  }, _this6.declareType = '认定';
                  _this6.getList();
                }
              });
            } else if (_this6.addDeclareType === '建设') {
              (0, _courseDeclare.insertFirstCourseThird)(_this6.form).then(function (res) {
                if (res.code === 2000) {
                  _this6.$message.success(res.msg);
                  _this6.dialog = false;
                  _this6.form = {
                    matchId: _this6.$route.query.id,
                    courseLeader: "",
                    courseName: ""
                  };
                  _this6.declareType = '建设';
                  _this6.getList();
                }
              });
            }
          }
        });
      }
    },
    //获取课程负责人列表
    getTeacherAll: function getTeacherAll() {
      var _this7 = this;
      (0, _courseDeclare.teacherAllList)({
        businessId: ''
      }).then(function (res) {
        var data = res.data;
        _this7.teacherAll = data;
      });
    },
    getDetail: function getDetail(e, i) {
      this.isDownBtn = i;
      if (e.state >= 6) {
        this.showDown = true;
      }
      if (this.declareType === '认定') {
        this.getDetailSecond(e.id);
      } else if (this.declareType === '建设') {
        this.getDetailThird(e.id);
      }
    },
    // 附件二 验收认定申报 根据id获取申报详情
    getDetailSecond: function getDetailSecond(id) {
      var _this8 = this;
      (0, _courseDeclare.getPreviewInfoByIdSecond)({
        id: id
      }).then(function (res) {
        var data = res.data;
        _this8.secondDetail = data;
        _this8.dialog2 = true;
      });
    },
    // 附件三 立项建设申报书 根据id获取申报详情
    getDetailThird: function getDetailThird(id) {
      var _this9 = this;
      (0, _courseDeclare.getPreviewInfoByIdThird)({
        id: id
      }).then(function (res) {
        var data = res.data;
        _this9.thirdDetail = data;
        _this9.dialog3 = true;
        _this9.thirdDetail.courseLeaderTeachingList.length ? _this9.teachingList = 4 + _this9.thirdDetail.courseLeaderTeachingList.length : _this9.teachingList = 5;
        _this9.thirdDetail.courseTeamList.length >= 5 ? _this9.teamList = 1 + _this9.thirdDetail.courseTeamList.length : _this9.teamList = 6 + _this9.thirdDetail.courseTeamList.length;
        _this9.thirdDetail.courseEachLectureList.length >= 5 ? _this9.lectureList = 1 + _this9.thirdDetail.courseEachLectureList.length : _this9.lectureList = 6 + _this9.thirdDetail.courseEachLectureList.length;
      });
    },
    // 获取申报列表 分页查询
    getList: function getList() {
      var _this0 = this;
      if (this.declareType === '认定') {
        (0, _courseDeclare.getSecondList)(this.page).then(function (res) {
          var data = res.data;
          _this0.listData = data.list;
          _this0.totalData = data.total;
        });
      } else if (this.declareType === '建设') {
        (0, _courseDeclare.getThirdList)(this.page).then(function (res) {
          var data = res.data;
          _this0.listData = data.list;
          _this0.totalData = data.total;
        });
      }
    },
    // 新增
    // save() {
    //   if (this.prCode === "guizhou") {
    //     this.$router.push("/object/objectGZ-add");
    //   } else {
    //     this.$router.push("/object/object-add");
    //   }
    // },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getList();
    }
  },
  computed: {
    htmlToPdfOptions: function htmlToPdfOptions() {
      return {
        margin: 0,
        filename: "附件.pdf",
        image: {
          type: "jpeg",
          quality: 0.98
        },
        enableLinks: true,
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: "in",
          format: 'a4',
          orientation: 'portrait'
        }
      };
    }
  },
  created: function created() {
    this.userInfo = this.$store.state.user.userInfo;
    this.getList();
    this.getTeacherAll();

    // console.log('userInfo',userInfo)
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    VueHtml2pdf: _vueHtml2pdf.default
  }
};